// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal_modal__wg_YU","active":"modal_active__ln9G9","content":"modal_content__EArjC","closeButton":"modal_closeButton__n6lBJ"};